import { GridCol, GridContainer, GridRow, mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export const Wrapper = styled(GridContainer)`
  ${mixins.margin.bottom(20)}
`

export const InfoWrapper = styled(GridCol)`
  display: flex;
  flex-direction: column;
`

export const AssetWrapper = styled(GridCol)`
  display: flex;
  justify-content: center;
  ${mixins.margin.top(20)};
  ${mixins.media.min.tablet} {
    ${mixins.margin.top(0)};
  }
`

export const AssetContent = styled(Asset)`
  width: 100%;
`

export const Title = styled.h3`
  ${mixins.typography.headlineLarge};
  ${mixins.margin(0)};
`

export const Description = styled.p`
  ${mixins.typography.paragraphMedium}
`

export const Teaser = styled.div``

export const SelectWrapper = styled.div`
  ${mixins.margin.top(30)};
  width: 100%;
  & select {
    ${mixins.media.min.desktop} {
      width: 70%;
    }
  }
  & select:not(:first-child) {
    ${mixins.margin.left(20)}
  }
`

export const DistributorsWrapper = styled(GridRow)`
  ${mixins.margin.top(20)};
`
